import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../../hooks/hooks";
import Table from "../../../../../common/components/table";
import { categories } from "../../../../../redux/categories/action";
import { selectCategoriesListItems } from "../../../../../redux/categories/selector";
import { useNavigate } from "react-router-dom";
import PageLoader from "../../../../../components/PageLoader";

const ManagementCategories = () => {
	const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
    const itemsData = useSelector(selectCategoriesListItems)
    const [pageSize, setPageSize] = useState(10);
    
    const [
        columnDefs,
        setColumnDefs
      ] = useState({});
      const createColumnDefs: any = () => {
        setColumnDefs([
          {
            field: 'Sl',
            sortable: false,
            filter: false,
            isSortLabel: true,
            headerName: 'Sl',
            cellRenderer (params: any) {
              return parseInt(
                params.node.id,
                10
              ) + 1;
            },
          },
          { field: 'Name', headerName: 'Name', sortable: true, filter: true},
          { field: 'IsSubCategory', headerName: 'SubCategory',cellRenderer: 'yesNoRenderer' },
          { field: 'ParentCategoryName', headerName: 'ParentCategory Name', sortable: true, filter: true },
          { field: 'CreatedOnUtc', headerName: 'CreatedOn',isDateValueFormat:true },
          { field: 'ModifiedOnUtc', headerName: 'ModifiedOn' ,isDateValueFormat:true},
        ]);
      }

      const handleAdd=()=>{
        navigate(`${0}`)
      }
      const handleEdit=(data: any)=>{
        
        navigate(`${data?.Id}`)
      }
      const handleDelete=(data: any)=>{
        dispatch(categories.delete({
          url: `https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/taxonomy/categories/delete`,
          entity: 'categories',
          jsonData: {
              Records: [
                  {
                      Id: data?.Id
                  }
              ]
          }
      })).then(() => {
          dispatch(categories.list({
              url: `https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/taxonomy/categories/list`,
              entity: 'categories',
              jsonData: { "PageNumber": pageData,
              "PageSize": pageSize,
              "SortField": "Id",
              "SortOrder": "desc",}
          }));
      });
      }
      const additionButtons: any = [
        {
          name: 'Add Categories',
          callback: () => handleAdd(),
        }
      ];
      const fetchCategories=()=>{
        dispatch(categories.list({
          url: `https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/taxonomy/categories/list`,
          entity: 'categories',
          jsonData: { "PageNumber": pageData,
          "PageSize": pageSize,
          "SortField": "Id",
          "SortOrder": "desc",}
      }));
      }
	useEffect(() => {
        createColumnDefs()
        fetchCategories()
	}, [pageData,pageSize])

	return (
  <>
     {itemsData?.isLoading ? <PageLoader />
 : 
  <Table columnData={columnDefs} rowData={itemsData?.result?.items} setPageData={setPageData} setPageSize={setPageSize}
  paginationData={itemsData?.result?.pagination} onEdit={handleEdit} onDelete={handleDelete} additionButtons={additionButtons} headingName="Categories" />
}
  </>
		
      
     
	);
};

export default ManagementCategories;


